import { getAllInvite, agree, reject } from 'api/index';
import { AllInviteItemType } from 'api/type';
import { _T } from '@dana/components';
import { useNavigate } from 'react-router-dom';
import { Popup, Toast } from 'react-vant';
import { useEffect, useState } from 'react';
import Nav from 'components/nav';

const fakeData = {
  guildName: '431241',
  masterId: '431241',
  nickName: '431241',
  avatar: '431241',
  guildId: 12323143,
  guildNo: 32142314,
  zone: 'SA',
  sex: 0,
  cover:
    'http://partynow-1327329234.cos.ap-hongkong.myqcloud.com/file/5140708f-47e2-45da-a7b9-31bc93ea2acesome_file.jpg',
};

interface HtmlRendererProps {
  htmlContent: string;
}

const HtmlRenderer: React.FC<HtmlRendererProps> = ({ htmlContent }) => {
  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default function InviteList() {
  const [list, setList] = useState<AllInviteItemType[]>();
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState('');
  const [guildId, setGuildId] = useState(0);

  const navigate = useNavigate();

  const fetchData = async () => {
    const res = await getAllInvite();
    setList(res);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const htmlString = type === 'reject' ? _T('拒绝') : _T('邀请');

  function go() {
    if (type === 'reject') {
      re();
    } else {
      ac();
    }
  }

  async function ac() {
    if (guildId) {
      const res = await agree(guildId);
      if (res) {
        setTimeout(() => {
          setVisible(false);
        });
        // ;(window as any).toFlutter.postMessage(JSON.stringify({
        //     "method": "inviteSuccess"
        // }))
        // Toast(_T('同意加入公会成功'))
        setTimeout(() => {
          navigate('/');
        }, 500);
      }
    }
  }

  async function re() {
    if (guildId) {
      const res = await reject(guildId);
      if (res) {
        setTimeout(() => {
          setVisible(false);
        });
        // Toast(_T('拒绝加入公会成功'))
        fetchData();
      }
    }
  }

  function setId(g: number, t: string) {
    setTimeout(() => {
      setVisible(true);
    });
    setGuildId(g);
    setType(t);
  }

  return (
    <div className="relative">
      <Popup
        visible={visible}
        onClose={() => {
          setTimeout(() => {
            setVisible(false);
          });
        }}
        round
      >
        <div className="w-[295px] h-[185px] flex flex-col justify-center items-center rounded-[16px] bg-[#fff]">
          <div className="text-customGray font-sans text-[18px] font-bold leading-normal capitalize">
            {_T('Tip')}
          </div>
          <div
            className="mt-[12px] w-[247px] text-customGreen text-center font-sfProText text-[14px] font-semibold leading-[20px]"
            dir="auto"
          >
            <HtmlRenderer htmlContent={htmlString} />
          </div>
          <div className="mt-[12px] flex justify-center items-center">
            <div
              className="w-[122px] h-[44px] rounded-[74px] flex justify-center items-center text-[#B1B1B1] font-sans text-[16px] font-bold leading-normal capitalize bg-[#f2f2f2]"
              onClick={() => {
                setTimeout(() => {
                  setVisible(false);
                });
              }}
              dir="auto"
            >
              {_T('取消')}
            </div>
            <div
              className="ml-[12px] w-[122px] h-[44px] rounded-[74px] flex justify-center items-center text-white font-sans text-[16px] font-bold leading-normal bg-gradient-to-r from-green-400 to-teal-500"
              dir="auto"
              onClick={go}
            >
              {_T('确定')}
            </div>
          </div>
        </div>
      </Popup>
      <Nav close={true} title={'加入公会邀请'}></Nav>
      <div
        className="w-[375px] bg-[#f2f2f5] pt-[12px]"
        style={{
          height: `${window.innerHeight - 115}px`,
        }}
      >
        {list &&
          list.length > 0 &&
          list.map((item) => (
            <div
              key={item?.masterId}
              className="mt-[12px] pl-[12px] mx-auto relative w-[351px] h-[90px] flex justify-start items-center rounded-lg bg-white"
            >
              <div
                className="w-[52px] h-[52px] rounded-full relative bg-cover"
                style={{
                  backgroundImage: `url(${item?.avatar || ''})`,
                }}
              ></div>
              <div className="flex flex-col justify-start items-start ml-[13px] mt-[5px]">
                <div className="flex justify-center items-center">
                  <div
                    className="max-w-[83px] text-[#333] font-sans text-[14px] font-bold leading-[18px] truncate text-center"
                    dir="auto"
                  >
                    {item?.nickName}
                  </div>
                  <div
                    className="ml-[5px] w-[18px] h-[18px] bg-cover font-abeezee"
                    style={{
                      backgroundImage: item?.country ? `url(${item?.country})` : '',
                    }}
                  ></div>
                </div>
                <div className="text-[#B3B3B3] font-sans font-semibold text-[14px] leading-[18px]">
                  ID:{item?.danaId || ''}
                </div>
                <div className="w-[163px] h-[18px] rounded-[4px] bg-[#F2F5F5] text-[10px] font-semibold leading-normal text-[#B3B3B3] font-sans capitalize flex justify-center items-center">
                  {_T('加入公会')}
                </div>
              </div>
              <div className="flex justify-center items-center absolute right-[12px] top-[20px]">
                <div
                  className="flex justify-center items-center text-[#fff] font-[600] text-[10px] leading-normal capitalize font-sans w-[66px] h-[26px] rounded-full bg-gradient-to-r from-[#7DD97F] to-[#16B28D]"
                  onClick={() => setId(item?.guildId, 'agree')}
                >
                  {_T('同意')}
                </div>
                <div
                  className="ml-[6px] flex justify-center items-center w-[66px] h-[26px] rounded-[74px] bg-[#F2F5F5] text-gray-400 font-sans font-semibold text-xs capitalize leading-normal"
                  onClick={() => setId(item?.guildId, 'reject')}
                >
                  {_T('拒绝')}
                </div>
              </div>
            </div>
          ))}

        {list && list.length === 0 && (
          <div className="absolute left-[50%] top-[50%] transfrom translate-x-[-50%] translate-y-[-50%] mx-auto">
            <div
              className="mx-auto w-[140px] h-[140px] bg-cover"
              style={{
                backgroundImage: `url(${type === 'search' ? require('asset/imgs/no-data1.png') : require('asset/imgs/no-data2.png')})`,
              }}
            ></div>
            <div
              dir="auto"
              className="text-gray-500 text-center font-sans text-sm font-[400] normal-case"
            >
              {_T('没有数据')}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
